import styled from '@emotion/styled';
import { useListingContext } from '~/editor/plugin/ListingPlugin';

const Section = styled.section`
	padding: 3rem 1.5rem;
	background: #f3f4f6;
	color: #111827;
`;

const Inner = styled.div`
	max-width: 73rem;
	margin: 0 auto;
	text-align: center;
`;

const Offered = styled.div`
	text-transform: lowercase;
	font-size: 1.5rem;
	font-weight: 500;
	margin-top: 1rem;
`;

const Price = styled.div`
	font-size: 3rem;
	margin-bottom: 2rem;
`;

const Stats = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	border-top: 1px dashed #d1d5db;
	border-bottom: 1px dashed #d1d5db;
	padding: 2rem 0;
	margin-bottom: 2rem;
	gap: 2rem;
`;

const Stat = styled.div`
	min-width: 120px;
`;

const StatValue = styled.div`
	font-size: 2rem;
`;

const StatLabel = styled.div`
	text-transform: uppercase;
	font-size: 1.5rem;
`;

const Body = styled.div`
	font-size: 1.5rem;
	line-height: 2.4rem;
	max-width: 60rem;
	margin: 0 auto;
	font-weight: 300;
`;

function formatLotSize(lotAcres?: number, lot?: number) {
	if (lotAcres) {
		return `${lotAcres.toFixed(2)} acres`;
	}
	if (lot) {
		return `${lot.toLocaleString()} sqft`;
	}
	return null;
}

export default function ListingBlockEpsilon() {
	const listing = useListingContext();
	const lotSize = formatLotSize(listing.lot_acres, listing.lot);

	return (
		<Section id="overview">
			<Inner>
				<Offered>offered at</Offered>
				{listing.price_formatted && <Price>${listing.price_formatted}</Price>}
				<Stats>
					{listing.beds != null && (
						<Stat>
							<StatValue>{listing.beds}</StatValue>
							<StatLabel>Beds</StatLabel>
						</Stat>
					)}
					{listing.baths != null && (
						<Stat>
							<StatValue>{listing.baths}</StatValue>
							<StatLabel>Baths</StatLabel>
						</Stat>
					)}
					{listing.sqft != null && (
						<Stat>
							<StatValue>{listing.sqft.toLocaleString()}</StatValue>
							<StatLabel>Sqft</StatLabel>
						</Stat>
					)}
					{lotSize && (
						<Stat>
							<StatValue>{lotSize}</StatValue>
							<StatLabel>Lot</StatLabel>
						</Stat>
					)}
				</Stats>
				{listing.body && <Body>{listing.body}</Body>}
			</Inner>
		</Section>
	);
}
